import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealersManagementComponent } from './dealers-management.component';
const routes: Routes = [
  {
    path: 'dealers-management',
    data: { name: 'dealers management', isTab: false },
    component: DealersManagementComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealersManagementRoutingModule {}
